import React from "react";

interface CellTimeProps {
  /** time in milliseconds */
  children: number;
}

const formatTime = (milliseconds: number): string => {
  if (!milliseconds || milliseconds < 0) return '0s';

  const seconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days}d ${hours % 24}h`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes % 60}m`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s`;
  }
  return `${seconds}s`;
};

const CellTime: React.FC<CellTimeProps> = ({ children }) => {
  const formattedTime = formatTime(Number(children));

  return (
    <span style={{ 
      fontFamily: 'monospace',
      fontSize: '0.875rem'
    }}>
      {formattedTime}
    </span>
  );
};

export default CellTime; 